import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Button, SvgIcon } from '@mui/material';
import './ButtonInputGroup.scss';

function ButtonInput(props) {
  return (
    <Button
      variant="contained"
      color="primary"
      className={props.className}
      onClick={props.onClick}
    >
      <span>
        <SvgIcon fontSize="small" component={props.icon} />
        <p>{props.title}</p>
      </span>
    </Button>
  );
}

export default function ButtonInputGroup(props) {
  return (
    <Container className="button-input-group shadow">
      <Row>
        {props.data.map((d, index) =>
          <Col key={index}>
            <ButtonInput
              title={d.label}
              icon={d.icon}
              className={`${index === 0 ? 'start' : index === props.data.length - 1 ? 'end' : ''} ${props.value === index ? 'active' : 'inactive'}`}
              onClick={() => props.onClick(index)}
            />
          </Col>
        )
        }
      </Row>
    </Container>
  );
}

ButtonInput.propTypes = {
  icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.object
  ]).isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

ButtonInputGroup.propTypes = {
  data: PropTypes.array.isRequired,
  value: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
};